import { runAgenticVercelStreamRequest } from "./runAgenticVercelStreamRequest";
import type { AgenticLegacyStreamChunk } from "./agenticVercelStreamConsumer";

export type { AgenticLegacyStreamChunk };

export type AgenticVercelChatSendRequest = {
  url: string;
  body: Record<string, unknown>;
  signal: AbortSignal | null | undefined;
  onChunk: (chunk: AgenticLegacyStreamChunk) => void;
  onDone: () => void;
  onError: (error: unknown) => void;
  onStart?: () => void;
};

/** Resumable Vercel transport entry point; mocked in persistentChatStore tests. */
export const sendViaAgenticVercelChat = runAgenticVercelStreamRequest;
